import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import {
  map,
  mergeMap,
  catchError,
  distinctUntilKeyChanged,
} from 'rxjs/operators';
import { CALL_DETAILS_ENTITY } from 'src/app/my-bill/call-details/config/entities';
import {
  getCallDetailsRequest,
  getCallDetailsSuccess,
  getCallDetailsFailure,
} from '../actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';

@Injectable()
export class CallDetailsEffects {
  getCallDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCallDetailsRequest),
      concatLatestFrom(() => this.store.select(selectCustomer)),
      mergeMap(([{ billingAccountNumber, documentId }, customer]) =>
        EntityManager.getEntity<string>(CALL_DETAILS_ENTITY, {
          cdbId: customer?.customerId,
          billingAccountNumber,
          documentId,
        }).pipe(
          distinctUntilKeyChanged('value'),
          map((entity) =>
            entity.value
              ? getCallDetailsSuccess({
                  csvResponse: entity.value,
                  entityUrl: entity.url,
                })
              : getCallDetailsFailure({})
          ),
          catchError((error) =>
            of(getCallDetailsFailure({ errorCode: error.errorData.code }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
